module.exports = __webpack_public_path__ + "static/media/courseG.abe7dfdf.png";